import { useState, useEffect } from "react";
import leftNav from "../images/team/left-nav.svg";
import rightNav from "../images/team/right-nav.svg";
import linkdin from "../images/team/linkdin.svg";
import SEO from "./SEO";

const Team = () => {
    const handleKeyDown = (event) => {
        if (event.key === "ArrowRight") {
            document.getElementsByClassName("right-nav")[0].click();
        } else if (event.key === "ArrowLeft") {
            document.getElementsByClassName("left-nav")[0].click();
        }
    };

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);

    const [factArray, changeFact] = useState([...Array(13).keys()]);
    const [navdisabled, updateNavStat] = useState(false);
    const [shift] = useState(9.3);
    const [team, updateTeam] = useState([]);

    useEffect(() => {
        const apiKey = process.env.REACT_APP_READ_API_TOKEN;
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `bearer ${apiKey}`);

        const requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("https://cms.insightforinnovation.in/api/teams", requestOptions)
            .then(response => response.json())
            .then(result => {
                const data = result?.data || [];
                const formatted = data.map(item => {
                    const attr = item.attributes;
                    return {
                        name: attr.name,
                        description: attr.description,
                        position: attr.position,
                        link: attr.link,
                        imageUrl: attr.imageUrl
                    };
                });

                updateTeam(formatted);

                const hemaIndex = formatted.findIndex(member => member.name.toLowerCase().includes("hema gopalakrishnan"));
                
                if (hemaIndex !== -1) {
                    // Create array where Hema is at index 5 (center position)
                    const rotated = [];
                    
                    for (let i = 0; i < formatted.length; i++) {
                        rotated[i] = (hemaIndex + i - 5 + formatted.length) % formatted.length;
                    }
                    
                    changeFact(rotated);
                } else {
                    changeFact([...Array(formatted.length).keys()]);
                }
            })
            .catch(error => console.error("Fetch team error:", error));
    }, []);

    const changeFactLeft = () => {
        if (navdisabled) return;
        document.getElementById("middle-member").className = "";
        document.getElementById("middle-member").classList.remove("middle-guy-2");
        void document.getElementById("middle-member").offsetWidth;
        document.getElementById("middle-member").classList.add("middle-guy-2");

        const modified = factArray.map(pos => (pos + 1) % team.length);
        changeFact(modified);

        updateNavStat(true);
        setTimeout(() => updateNavStat(false), 500);
    };

    const changeFactRight = () => {
        if (navdisabled) return;
        document.getElementById("middle-member").className = "";
        document.getElementById("middle-member").classList.remove("middle-guy");
        void document.getElementById("middle-member").offsetWidth;
        document.getElementById("middle-member").classList.add("middle-guy");

        const modified = factArray.map(pos => (pos - 1 + team.length) % team.length);
        changeFact(modified);

        updateNavStat(true);
        setTimeout(() => updateNavStat(false), 500);
    };

    // Get the center member (the one at index 5 in factArray)
    const centerMember = team[factArray[5]];

    return (
        <section className="team nav-offset">
            <SEO
                title="Meet Our Team | Empowering Our Kids Through Education | Insight for Innovation"
                description="Get to know the dedicated and passionate team behind Insight for Innovation..."
                canonicalEnd="team"
            />
            <div className="team-heading">
                <h1>Strength in Unity</h1>
                <p>Introducing the passionate and skilled members of our team</p>
            </div>
            <div className="team-container">
                {
                    team.length > 0 && factArray.map((pos, index) => {
                        const member = team[pos];
                        const leftValue = (shift * index) + "%";
                        const visible = shift * index >= 0 && shift * index <= shift * 10;
                        
                        // Skip rendering the center member in the carousel to avoid duplication
                        if (index === 5) {
                            return null;
                        }

                        return (
                            <div
                                key={pos}
                                className={index % 2 === 0 ? "variation-left-container" : "variation-right-container"}
                                style={{ left: leftValue, opacity: visible ? 1 : 0 }}
                            >
                                <img src={member.imageUrl} alt="Team member" loading="lazy"/>
                            </div>
                        );
                    })
                }
                {team.length > 0 && centerMember && (
                    <img
                        className="middle-guy"
                        id="middle-member"
                        src={centerMember.imageUrl}
                        alt="Team member"
                    />
                )}
            </div>
            {
                team.length > 0 && centerMember &&
                <div className="team-bottom-section">
                    <img className="left-nav" src={leftNav} alt="Left" onClick={changeFactLeft} />
                    <div className="middle-section">
                        <h1>{centerMember.name}</h1>
                        <p style={{ fontSize: "20px", textTransform: "capitalize" }}>
                            {centerMember.position}
                        </p>
                        <img
                            src={linkdin}
                            alt="LinkedIn"
                            className="linkdin"
                            onClick={() => window.open(centerMember.link)}
                        />
                          <p style={{ fontSize: "15px",}}>
                            {centerMember.description}
                        </p>
                    </div>
                    <img className="right-nav" src={rightNav} alt="Right" onClick={changeFactRight} />
                </div>
            }
        </section>
    );
};

export default Team;